<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      :readonly="readonly"
      option-label="event_name"
      option-value="id"
      :emit-value="true"
      map-options
      :multiple="multiple"
      :loading="dataLoading"
      :options="options"
      @filter="filterFn"
      v-bind="siteCFG.fields.general"
      @input="$emit('changed', model)"
      :chips="chips"
    >
      <template v-slot:option="scope">
        <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
          <q-item-section>
            <q-item-label
              v-if="scope.opt.messages && scope.opt.messages.length > 0"
            >
              {{ scope.opt.event_name }}
              <q-icon name="mdi-alert"></q-icon>
            </q-item-label>
            <q-item-label v-else>
              <q-checkbox
                v-model="scope.selected"
                v-on:click.native="scope.toggleOption(scope.opt)"
              ></q-checkbox>
              {{ scope.opt.event_name }}
            </q-item-label>
          </q-item-section>
          <q-tooltip v-if="scope.opt.messages && scope.opt.messages.length > 0">
            <h6 class="q-my-xs" style="font-size: 14px">
              Unfortunately {{ filterToMember.firstName }}
              {{ filterToMember.lastName }} cannot be entered for this event
              because:
            </h6>
            <div
              v-for="(message, index) in scope.opt.messages"
              :key="`message_${index}`"
              style="font-size: 12px"
            >
              {{ message }}
            </div>
          </q-tooltip>
        </q-item>
      </template>
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No Events </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    props: {
      id: {
        default: null,
      },
      label: {
        type: String,
        default: "Assign Event",
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      filterToMember: {
        default: null,
      },
      individualEventsOnly: {
        default: false,
      },
      excludeEvents: {
        default: null,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      chips: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        data: "events/listForCompetitionOrderedDivision",
        dataLoading: "events/listForCompetitionLoading",
        competition: "competitions/current",
        divisions: "divisions/list",
        siteCFG: "settings/siteCFG",
      }),
    },
    watch: {
      id: function () {
        this.model = this.id;
      },
      users: function () {
        this.model = this.id;
      },
    },
    data: () => ({
      model: [],
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(JSON.stringify(this.data));
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(JSON.stringify(this.data)).filter((v) => {
              let memberFilter = true;
              if (this.filterToMember) {
                memberFilter = this.runFilterToMember(v);
              }
              if (memberFilter && this.excludeEvents) {
                memberFilter = !this.excludeEvents.includes(v.id);
              }

              return memberFilter;
            });
            this.options.sort((a, b) => {
              if (
                a.messages &&
                a.messages.length > 0 &&
                (!b.messages || b.messages.length == 0)
              ) {
                return 1;
              } else if (
                (!a.messages || a.messages.length == 0) &&
                b.messages &&
                b.messages.length > 0
              ) {
                return -1;
              } else {
                return 0;
              }
            });
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = this.data.filter((v) => {
              let textMatch = v.event_name.toLowerCase().indexOf(needle) > -1;
              let memberFilter = true;
              if (this.filterToMember) {
                memberFilter = this.runFilterToMember(v);
              }
              if (memberFilter && this.excludeEvents) {
                memberFilter = !this.excludeEvents.includes(v.id);
              }
              return textMatch && memberFilter ? true : false;
            });
            this.options.sort((a, b) => {
              if (
                a.messages &&
                a.messages.length > 0 &&
                (!b.messages || b.messages.length == 0)
              ) {
                return 1;
              } else if (
                (!a.messages || a.messages.length == 0) &&
                b.messages &&
                b.messages.length > 0
              ) {
                return -1;
              } else {
                return 0;
              }
            });
          });
        }
      },
      runFilterToMember(event) {
        let passed = false;
        let age = moment(this.competition.age_reference_date).diff(
          this.filterToMember.birthDate,
          "years",
          false
        );

        // console.log(age, event.age_min);

        if (
          event.gender &&
          (event.gender == "X" || event.gender == this.filterToMember.gender) &&
          age >= event.age_min &&
          age <= event.age_max
        ) {
          passed = true;
        } else {
          return false;
        }
        // console.log(event);

        if (event.playerLabels != null && this.filterToMember.crm_id) {
          let playerLabels = JSON.parse(event.playerLabels);
          let result = this.checkAwards(playerLabels, event, this.filterToMember);
          event.messages = result.messages;
          passed = result.display;
          event.disable = !result.passed;
        }

        if (
          this.individualEventsOnly &&
          JSON.parse(event.playerLabels).filter((l) => l.required == 1).length > 1
        ) {
          passed = false;
        }
        return passed;
      },
      checkAwards(playerLabels, event, member) {
        // Calculating the members age because the SLG and 200M award only applies after they are 14 (SLG) or under 14 (200M)
        let result = {
          passed: true,
          display: true,
          messages: [],
        };
        let age = moment(event.refresher_reference_date).diff(
          member.birthDate,
          "years",
          false
        );

        // Check if a player Label Exists
        if (playerLabels.length == 0) {
          result.passed = false;
          result.display = false;
          result.messages.push("Event Setup Not Complete");
          return result;
        }

        // Check if needs to be individualEvent or not
        if (
          this.individualEventsOnly &&
          playerLabels.filter((l) => l.required == 1).length > 1
        ) {
          result.passed = false;
          result.display = false;
          result.messages.push("Not an individual event");
          return result;
        }

        // Check crew award
        if (playerLabels[0].crew == 1) {
          let award = member.awards.find((a) => a.awards_id == 4);
          if (!award) {
            result.passed = false;
            result.messages.push("Athlete has no valid IRB Crew award");
          }
        }

        // Check driver award
        if (playerLabels[0].driver == 1) {
          let award = member.awards.find(
            (a) =>
              (a.awards_id == 2 || a.awards_id == 6) &&
              moment(a.refresher_date) >= moment(event.refresher_reference_date)
          );
          if (!award) {
            result.passed = false;
            result.messages.push("Athlete has no valid IRB Driver award");
          }
        }

        // Check patrolSupport award
        if (playerLabels[0].patrolSupport == 1 && age >= 14) {
          // Patrol support awards can enter Beach events, and Life guard support awards override patrol support
          // console.log(member.awards, moment(event.refresher_reference_date));
          let award = member.awards.find(
            (a) =>
              (a.awards_id == 15 ||
                a.awards_id == 11 ||
                a.awards_id == 2 ||
                a.awards_id == 5 ||
                a.awards_id == 6 ||
                a.awards_id == 22 ||
                a.awards_id == 23) &&
              moment(a.refresher_date) >= moment(event.refresher_reference_date)
          );
          if (!award) {
            result.passed = false;
            result.messages.push(
              "Athlete has no valid Patrol Support or SLG award"
            );
          }
        }

        // check slg award
        if (playerLabels[0].slg == 1 && age >= 14) {
          let award = member.awards.find(
            (a) =>
              (a.awards_id == 22 || a.awards_id == 23) &&
              moment(a.refresher_date) >= moment(event.refresher_reference_date)
          );
          if (!award) {
            result.passed = false;
            result.messages.push("Athlete has no valid SLG award");
          }
        }

        // check twoHundredMeter award
        if (playerLabels[0].twoHundredMeter == 1 && age < 14) {
          // Calculating the members age because this award only applies after they are 14
          // let age = moment(event.refresher_reference_date).diff(
          //   member.birthDate,
          //   "years",
          //   false
          // );

          let award = member.awards.find(
            (a) =>
              (a.awards_id == 3 || a.awards_id == 17) &&
              moment(a.refresher_date) >= moment(event.refresher_reference_date)
          );
          if (!award) {
            result.passed = false;
            result.messages.push("Athlete has no valid 200m award");
          }
        }

        return result;
      },
      selectItem(data) {
        if (data.messages && data.messages.length > 0) {
          // console.log("Cannot Add Event");
        } else {
          this.model = data.id;
          this.$emit("changed", this.model);
        }
      },
    },
  };
</script>
